module.exports = __webpack_public_path__ + "static/media/gryllotalpa_gryllotalpa_003_APA.e3ae1a11.mp3";